// @ts-nocheck
import React, { useState, useEffect } from 'react';
import Router, { useRouter } from 'next/router';
import * as Enums from '@/utils/enums';
import Storage from '@/utils/storage';
import Helper from '@/utils/helper';
import SettingsMenu from "@/components/settings/menu";
import {Box, Flex} from "@mantine/core";
import SettingsFormList from "@/PageComponents/Table/Component Tables/SettingsFormList";
import { createFileRoute } from '@tanstack/react-router'



const FormDefinitionList = (props: any) => {

    const router = useRouter()

    const [accessStatus, setAccessStatus] = useState(Enums.AccessStatus.None)

    const getAccessStatus = () => {
        let subscriptionInfo = Storage.getCookie(Enums.Cookie.subscriptionInfo)
        if (subscriptionInfo) {
            setAccessStatus(subscriptionInfo.AccessStatus)
        }
    };

    useEffect(() => {
        if (accessStatus === Enums.AccessStatus.LockedWithOutAccess) {
            Helper.nextRouter(Router.replace, "/");
        }
    }, [accessStatus])


    useEffect(() => {
        getAccessStatus()
    }, []);

    return (
        <div className="settings-container">
            <Flex>
                <SettingsMenu urlPath={router.asPath} />
                <div className="settings-card">
                    <SettingsFormList />
                </div>
            </Flex>
        </div>
    );
};


export default FormDefinitionList;

export const Route = createFileRoute('/_authenticated/settings/form/list')({ component: FormDefinitionList })
